import { CreditCategory } from "../../../models/accounting/credit/credit-category";
import { CreditReason } from "../../../models/accounting/credit/credit-reason";
import { Division } from "../../../models/accounting/enums/division";
import { JsonProperty } from "../../../models/utilities/json-property";
import { Price } from "../../../models/utilities/price";

export class DealerCreditLineItem {

    public reasonId: number | undefined = undefined;

    public categoryId: number | undefined = undefined;

    public description: string = '';

    public amount: Price = new Price();

    public reason: CreditReason | undefined = undefined;

    public category: CreditCategory | undefined = undefined;

}

export class DealerCredit {

    public id: number = 0;

    @JsonProperty({ toType: 'datetime' })
    public createdOn: Date | undefined = undefined;

    public dealerId: string = '';

    public currencyId: string = '';

    public division: Division | undefined = undefined;

    public serviceCenterId: string = '';

    public exchangeRate: number = 0.0;

    public invoiceId : number = 0;
    
    public invoiceNumber : string = '';

    public note : string = '';

    public isReversed : boolean = false;
    
    @JsonProperty({ toClass: Price })
    public subtotal: Price = new Price();

    @JsonProperty({ toClass: Price })
    public freight: Price = new Price();

    @JsonProperty({ toClass: Price })
    public tax: Price = new Price();

    @JsonProperty({ toClass: Price })
    public total: Price = new Price();

    @JsonProperty({ toClass: DealerCreditLineItem, designType: 'array' })
    public items: DealerCreditLineItem[] = [];
}
